export default __webpack_public_path__ + "static/media/walletconnect.80a855f2.png";